import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-get-instant-courses-two',
  templateUrl: './get-instant-courses-two.component.html',
  styleUrls: ['./get-instant-courses-two.component.scss']
})
export class GetInstantCoursesTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
